import React from "react";
import $ from "jquery";
import Html from "utils/Html";
import Func from "utils/Func";
import { useNotify } from "context/NotifyContext";

export default function SelectPage() {
  const { filters, storeFilters, results } = useNotify();
  const handleEvents = {
    OnClick: function (evt) {
      evt.preventDefault();
      let page = $(evt.target).attr("page-index");
      if (page === undefined) {
        let li = $(evt.target).parents("li");
        if ($(li).hasClass("disabled")) {
          return;
        }
        page = $(evt.target).parent().attr("page-index");
      }
      storeFilters({
        ...filters,
        limit: $("#select-limit-row").val(),
        page: page,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };
  return (
    <Html.Paginations
      totalPage={results.total_page}
      activePage={results.active_page}
      className={"table-pagination"}
      handleEvents={handleEvents.OnClick}
    />
  );
}
